<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-cancel"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base-close" @click="hide()">
                <img src="@/assets/profile/close-new.svg" alt="" />
            </div>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p>{{ title }}</p>
                </div>
                <div
                    @click="clickCheckBox('nescafe')"
                    class="radio-container margin-bottom"
                >
                    <img
                        v-if="active === 'nescafe'"
                        src="@/assets/icon/radio_active.svg"
                        alt=""
                    />
                    <img v-else src="@/assets/icon/radio_inactive.svg" alt="" />
                    <div class="radio-choice">{{ nescafe }}</div>
                </div>
                <div @click="clickCheckBox('all')" class="radio-container">
                    <img
                        v-if="active === 'all'"
                        src="@/assets/icon/radio_active.svg"
                        alt=""
                    />
                    <img v-else src="@/assets/icon/radio_inactive.svg" alt="" />
                    <div class="radio-choice">{{ all }}</div>
                </div>
                <div class="nestle-list" v-html="nestleList"></div>
                <div class="modal-base-body" v-html="message"></div>
                <div class="modal-base-footer">
                    <div class="button brown-btn" @click="clickKeep(true)">
                        {{ btnKeep }}
                    </div>
                    <div
                        class="button underline-black-btn"
                        @click="clickKeep(false)"
                    >
                        {{ btnNotKeep }}
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";

/**
 * @property {CancelModalController} controller (required) /components/Modal/Controller/CancelModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "CancelModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },

    data: function () {
        return {
            title: "",
            nescafe: "",
            all: "",
            nestleList: "",
            message: "",
            btnKeep: "",
            btnNotKeep: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),

            active: "nescafe",
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickKeep: function (keepData) {
            this.hide();
            let params = {
                keepData: keepData,
                active: this.active,
            };

            this.controller.sendCallback(params);
        },
        clickCheckBox: function (data) {
            this.active = data;
        },
        show: function (config) {
            this.title = config.title;
            (this.nescafe = config.nescafe),
                (this.all = config.all),
                (this.nestleList = config.nestleList),
                (this.message = config.message);
            (this.btnKeep = config.btnKeep),
                (this.btnNotKeep = config.btnNotKeep),
                (this.tag = config.tag);
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
    },
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
@import "@/module/Order/style/orderStyle.scss";
@import "@/style/_mixin.scss";
.modal-cancel {
    .modal-base {
        .radio-container {
            display: flex;
            align-items: center;
            .radio-choice {
                margin-left: 10px;
                color: $color-text;
                font-size: 16px;
            }
            &.margin-bottom {
                margin-bottom: 12px;
            }
        }
        .nestle-list {
            margin-left: 34px;
            font-size: 14px;
            margin-bottom: 12px;
            color: $color-brown-600;
        }
    }
}
</style>
